import React from "react";
import { groupBy, sortBy } from "lodash";
import { Tooltip } from '@mui/material'
import classnames from "classnames";
import { getPeriodNames } from "../../../helpers/enrolment";
import { withRouter } from "react-router-dom";
import { vuMainUnitLink } from "../../../helpers/links";
import { Check, Done } from "@mui/icons-material";

class CoursePattern extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  handleReturnToSummary = (event) => {
    this.props.courseBackButtonClicked();
    event.preventDefault();
  };

  getTitle = () => {
    return this.props.studyPeriodCodes
      .map((studyPeriodCode) => getPeriodNames(studyPeriodCode))
      .reduce((accumulator = [], currentValue) => {
        if (!accumulator.some((value) => value === currentValue)) {
          return accumulator.concat(currentValue);
        }
        return accumulator;
      }, [])
      .reduce((accumulator, currentValue, index, array) => {
        if (index === 0) {
          return currentValue;
        }

        if (index === array.length - 1) {
          return accumulator + " and " + currentValue;
        }

        return accumulator + ", " + currentValue;
      }, "");
  };

  getStudyPackages = () => {
    return this.props.studyPackages.filter((studyPackage) => {
      return (
        studyPackage.unitAvailabilityYear === this.props.availabilityYear &&
        this.props.studyPeriodCodes.some((studyPeriodCode) => {
          return (
            studyPackage.unitAvailabilityStudyPeriodCode === studyPeriodCode
          );
        })
      );
    });
  };

  isValidStudyPeriodForStudyPackage = (
    studyPackage,
    studyPeriodCode,
    availabilityYear,
  ) => {
    return (
      studyPackage.unitAvailabilityYear === availabilityYear &&
      studyPackage.unitAvailabilityStudyPeriodCode === studyPeriodCode
    );
  };

  sortStudyPackages = (studyPackages = []) => groupBy(sortBy(studyPackages, ['unitAvailabilityYear', 'unitCode']), 'unitCode')

  renderUnitSetTableBody = groupByUnitCode => {
    return Object.keys(groupByUnitCode).map(key => {
      let studyPackageByUnitCode = groupByUnitCode[key]
      return (
        <tr key={key}>
          <th>
            <Tooltip
              className="tooltip"
              title={
                <React.Fragment>
                  <b>{studyPackageByUnitCode[0].unitShortTitle}</b>
                  {studyPackageByUnitCode[0].unitRequisiteFlag && (
                    <>
                      <br />
                      This unit has prerequisites
                    </>
                  )}
                </React.Fragment>
              }
            >
              <span>{vuMainUnitLink(key, key, 'colorWhite')}</span>
            </Tooltip>
          </th>
          {this.props.studyPeriodCodes.map(studyPeriodCode => {
            const studyPackages = studyPackageByUnitCode.filter(
              studyPackage => studyPackage.unitAvailabilityStudyPeriodCode === studyPeriodCode && studyPackage.unitAvailabilityYear === this.props.availabilityYear
            )
            if (studyPackages && studyPackages.length > 0) {
              const studyPackageHasQuota = studyPackages.filter(
                studyPackage => studyPackage.unitAvailabilityMaxQuota === 0 || (studyPackage.unitAvailabilityMaxQuota > 0 && studyPackage.unitAvailabilityQuotaRemaining > 0)
              )

              const available = studyPackageHasQuota && studyPackageHasQuota.length > 0
              return (
                <td key={studyPeriodCode} className={classnames({ available: available }, { unavailable: !available })}>
                  <Tooltip className="tooltip" title={available ? 'Available' : 'Full'}>
                    <Check />
                  </Tooltip>
                </td>
              )
            }

            return <td key={studyPeriodCode}>&nbsp;</td>
          })}
        </tr>
      )
    })
  }

  renderUnitSetTable = (studyPackages = []) => {
    return (
      <div key={studyPackages[0].courseSSPNumber}>
        <h3>Core units</h3>
        <table>
          <thead>
            <tr>
              <th>&nbsp;</th>
              {this.props.studyPeriodCodes.map((studyPeriodCode) => (
                <th key={studyPeriodCode}>{studyPeriodCode}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {this.renderUnitSetTableBody(this.sortStudyPackages(studyPackages))}
          </tbody>
        </table>
      </div>
    );
  };

  render() {
    return (
      <div className="enrolment-guide__content enrolment-guide__content--course-pattern">
        <div className="nav-back" onClick={this.handleReturnToSummary}>
          <button className="btn" tabIndex={this.props.focusable ? 0 : -1}>
            Back
          </button>
        </div>

        <h2>
          <span>{this.props.availabilityYear}</span> - {this.getTitle()}
        </h2>
        <div className="legend-container">
          <div className="legend-item">
            <span className="key tick-available">
              <Done />
            </span>
            <span className="key-txt"> Classes are available</span>
          </div>
          <div className="legend-item">
            <span className="key tick-unavailable">
              <Done />
            </span>
            <span className="key-txt">Classes are full</span>
          </div>
        </div>

        {this.props.focusable &&
          this.renderUnitSetTable(this.getStudyPackages())}
      </div>
    );
  }
}

export default withRouter(CoursePattern);
